import { AppBar, Tab, Tabs, WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { CodeOutlined, DeveloperBoardOutlined, HomeOutlined, HomeWorkOutlined, InfoOutlined } from '@material-ui/icons';
import 'moment/locale/it';
import React, { ReactElement } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import * as ModalsActions from '../../redux/modals/modals.actions';
import * as ProductInfoActions from '../../redux/productinfo/productinfo.actions';
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';
import translations from "../../translations/i18next";

const styles = createStyles({
  header: {
    backgroundColor: 'white',
    width: '100%',
    zIndex: 200,
    padding: 10,
    paddingRight: 20,
    borderBottom: '2px solid #5AC0B1',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
});

type IReduxProps = ConnectedProps<typeof connector>;

export interface IDevelopersResourceProps extends WithStyles<typeof styles> {
  language: string;
}

export type ComponentProps = IDevelopersResourceProps & IReduxProps;

export interface IDevelopersCategory {
  tabIndex: number;
  category: string;
  label: string;
  icon: ReactElement<any,any>;
};

export const developersCategories: IDevelopersCategory[] = [
  {
    tabIndex: 0,
    category: 'INTRO',
    label: translations.t('developers.integrationInfo'),
    icon: <InfoOutlined style={{ fontSize: 25 }} />,
  },
  {
    tabIndex: 1,
    category: 'API',
    label: translations.t('developers.api'),
    icon: <CodeOutlined style={{ fontSize: 25 }} />,
  },
  {
    tabIndex: 2,
    category: 'SDK',
    label: translations.t('developers.sdk'),
    icon: <DeveloperBoardOutlined style={{ fontSize: 25 }} />,
  },
  {
    tabIndex: 3,
    category: 'KNX',
    label: translations.t('developers.knx'),
    icon: <DeveloperBoardOutlined style={{ fontSize: 25 }} />,
  },
]

export interface IDevelopersResourceState {
  activeTab: number;
};

class DevelopersResource extends React.Component<ComponentProps,IDevelopersResourceState> {

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
      activeTab: 0,
    };
  }

  async componentDidMount() {
    const { dispatch, language } = this.props;
    try {
      await dispatch<any>(ProductInfoActions.fetchDevelopersPost(language, developersCategories[0].category));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_OPEN_DEVELOPERS_RESOURCES`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.openDevelopersResourcesError',
        }
      }));
    }
  }

  public onTabChange(index: number) {
    const { dispatch, language } = this.props;
    this.setState({ activeTab: index });
    const foundCategory = developersCategories.find(e => e.tabIndex === index);
    const category = foundCategory ? foundCategory.category : '';
    dispatch<any>(ProductInfoActions.fetchDevelopersPost(language, category));
  }

  render() {
    const { classes, developersPosts } = this.props;
    const { activeTab } = this.state;
    return (
      <div className={classes.container}>
        <AppBar position="sticky" style={{ backgroundColor: 'white' }}>
          <Tabs
            value={activeTab}
            centered
            indicatorColor="primary"
            textColor="primary"
            style={{ backgroundColor: 'white', width: '100%' }}
            onChange={(e, index) => this.onTabChange(index)}
          >
            <Tab key={0} icon={<InfoOutlined />} label={<h5 style={{ margin: 0 }}>{translations.t('developers.integrationInfo')}</h5>} />
            <Tab key={1} icon={<CodeOutlined />} label={<h5 style={{ margin: 0 }}>{translations.t('developers.api')}</h5>} />
            <Tab key={2} icon={<DeveloperBoardOutlined />} label={<h5 style={{ margin: 0 }}>{translations.t('developers.sdk')}</h5>} />
            <Tab key={3} icon={<HomeOutlined />} label={<h5 style={{ margin: 0 }}>{translations.t('developers.knx')}</h5>} />
          </Tabs>
        </AppBar>
        <div style={{ backgroundColor: 'white'}}>
          {developersPosts.map((post,index) => (
            <div
              key={index}
              style={{ minHeight: '600', padding: 25, paddingLeft: 20, paddingTop: 10, marginBottom: 0, backgroundColor: 'white' }} 
              dangerouslySetInnerHTML={{ __html: post.content.rendered }} 
            />
          ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    developersPosts: state.productInfo.developersPosts.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withStyles(styles)(DevelopersResource as any));
